import {
    IFloatFormItemProps,
    IFormItemElement,
    IIntFormItemProps,
    IStringFormItemProps,
    TextFormItem
} from "../model/FormModel";
import React, {HTMLAttributes, RefAttributes} from "react";
import {JSX} from "react/jsx-runtime";
import IntrinsicAttributes = JSX.IntrinsicAttributes;
import {StyleReactProps} from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import {IonTextarea} from "@ionic/react";

export interface IFormInputProps extends IFormItemElement
{
    formItemProps:IStringFormItemProps|IFloatFormItemProps|IIntFormItemProps;
    elementProps?:IntrinsicAttributes & React.ComponentProps<typeof IonTextarea> & Omit<HTMLAttributes<HTMLIonInputElement>, "style"> & StyleReactProps & RefAttributes<typeof IonTextarea>
}

const TextAreaFIE = (props: IFormInputProps) =>
{
    let {
        form,
        formItemProps,
        label,
        instructions,
        onItemChange,
        children,
        elementProps
    } = props;

    const formItem = form.requireFormItem(formItemProps, "string", true) as TextFormItem;

    label = label ?? formItem.name;

    const onInput = (event:CustomEvent) => {
        if(!formItem.setValue(event.detail.value ?? "")){
            return;
        }

        if(onItemChange){
            onItemChange(formItem.itemID);
            form.refreshState();
        } else if(onItemChange !== null){
            form.onFormItemChange(formItem.itemID);
        }
    }
    return <fieldset className={form.isFormItemHidden(formItem) ? "d-none" : ""}>
        <div className="row">
            <div className="col-12">
                <IonTextarea
                    {...elementProps}
                    data-form-item-id={formItem.itemID}
                    label={label}
                    labelPlacement={elementProps?.labelPlacement ?? "stacked"}
                    className={'ion-touched ' + (formItem.errorText ? 'ion-invalid ' : '') + (elementProps?.className ?? "") + (formItem.required ? " required" : "")}
                    errorText={formItem.errorText}
                    data-error-for-form-item-id={formItem.itemID}
                    name={formItem.itemID}
                    onIonInput={onInput}
                    value={formItem.value}
                >
                    {children}
                </IonTextarea>
            </div>
            {!!instructions && (
                <div className="col-12">
                    <span className="instructions">{instructions}</span>
                </div>
            )}
        </div>
    </fieldset>;
}

export default TextAreaFIE;